import React from 'react';
import styles from './EventStatusBadge.module.css';

// `status` = the object returned by utils/eventHelpers.getEventStatus(event)
export default function EventStatusBadge({ status }) {
    return (
        <span className={`${styles.statusBadge} ${styles[`status_${status.color}`]}`}>
            {status.color === 'active' && <span className={styles.statusDot} />}
            {status.label}
        </span>
    );
}
